import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/node_modules/.pnpm/next-intl@4.13.0_next@15.5.27_@playwright+test@1.60.0_@types+node@24.19.2_react-dom@19.1.0_re_4w2gdpissv46u5f5yordegg4qi/node_modules/next-intl/dist/esm/production/shared/NextIntlClientProvider.js");
;
import(/* webpackMode: "eager", webpackExports: ["CookieConsent"] */ "/app/src/components/CookieConsent/CookieConsent.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["CookieConsentLoader"] */ "/app/src/components/CookieConsent/CookieConsentLoader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MarketingAnalyticsLoader"] */ "/app/src/components/MarketingAnalytics/MarketingAnalyticsLoader.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Footer"] */ "/app/src/components/MarketingShell/subcomponents/Footer/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Nav"] */ "/app/src/components/MarketingShell/subcomponents/Nav/Nav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScrollToHash"] */ "/app/src/components/ScrollToHash/ScrollToHash.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AppProviders"] */ "/app/src/providers/AppProviders.tsx");
